import useBackground from "hooks/useBackground";
import useMediaQueries from "hooks/useMediaQueries";

import { useContent } from "contexts/contentContext/contentContext";
import { useEffect, useRef, useState } from "react";

import styles from "./styles.module.scss";

// ratio of FUll HD screen
const RATIO = 1920 / 1080;
const MOBILE_RATIO = 1080 / 1920;

const AdBackground = () => {
  const { getAdsBackground, setAdsBackground } = useContent();
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const { mobileCondition } = useMediaQueries();
  const [height, setHeight] = useState<number>(
    window.innerWidth / (mobileCondition ? MOBILE_RATIO : RATIO)
  );
  const { updateAdViewCount } = useBackground();

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerWidth / (mobileCondition ? MOBILE_RATIO : RATIO));
    };

    // Change ratio on window resize
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [mobileCondition]);

  const detectIframeBlocked = async () => {
    const iframe = iframeRef.current;
    if (iframe) {
      if (iframe.contentWindow && iframe.contentWindow.length === 0) {
        await updateAdViewCount();
      
        setAdsBackground({ ...getAdsBackground(), isBlocked: true });
      }
    }
  };

  return getAdsBackground() &&
    !getAdsBackground().isBlocked &&
    getAdsBackground()?.script ? (
    <div
      className={styles.iframeContainer}
      style={{
        height: `${height}px`,
      }}
    >
      <iframe
        ref={iframeRef}
        onLoad={detectIframeBlocked}
        srcDoc={`<script src='${getAdsBackground()?.script}'></script>`}
        title="Ad Background"
        height={height}
      />
    </div>
  ) : null;
};

export default AdBackground;
